import { FlexDiv } from 'components/generic/HomePageComponents'

export const TopCitiesMainContainer = (props) => {
  return (
    <FlexDiv
      flexDirection='row'
      width='100%'
      justifyContent='center'
      bg='textColor'
      paddingBottom='10px'
    >
      <FlexDiv
        flexDirection='column'
        maxWidth={{ _: '90vw', desktop: '992px' }}
        flexWrap='wrap'
        {...props}
      />
    </FlexDiv>
  )
}

export default TopCitiesMainContainer
